module.exports = __webpack_public_path__ + "img/slider_1.0dd56151.jpg";